import type { ReactNode } from 'react';
import { Anchor, Group, Stack, Text, Title } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { IconArrowLeft } from '@tabler/icons-react';

interface ReportPageProps {
  title: string;
  description?: string;
  /** Slot for the report's CSV button (and, for mass-balance/genealogy, nothing —
   * they gate CSV behind having a result first, so those screens render it
   * themselves inline instead of passing it here). */
  action?: ReactNode;
  children: ReactNode;
}

/** Shared page chrome for every report + register screen (goal text: "A shared
 * report-table + filter-bar component in your feature folder keeps the 12
 * consistent"). Reports hub has 13 sub-pages, too many for a persistent tab bar
 * (unlike the smaller screen groups' Tabs/Button-row layouts) — each screen
 * instead carries its own "back to hub" breadcrumb via this wrapper. */
export function ReportPage({ title, description, action, children }: ReportPageProps) {
  return (
    <Stack gap="md">
      <Group justify="space-between" align="flex-start" wrap="wrap" gap="md">
        <Stack gap={2}>
          <Anchor component={Link} to="/reports" size="sm" c="dimmed" underline="hover">
            <Group gap={4} wrap="nowrap">
              <IconArrowLeft size={14} />
              <span>Reports</span>
            </Group>
          </Anchor>
          <Title order={2}>{title}</Title>
          {description && (
            <Text c="dimmed" size="sm" maw={640}>
              {description}
            </Text>
          )}
        </Stack>
        {action}
      </Group>
      {children}
    </Stack>
  );
}
